import type { SelectOption } from '@lbcamden/lib-react';

import { DisplayValuesMap } from '~/common/types/data';

import { PaginatedData } from '../types/search';

export type DisplayValueMaps = Record<string, Record<string, string>>;

export const displayValueEntries = <TValue extends string>(
  displayValues: DisplayValuesMap<TValue>,
) => Object.entries(displayValues) as [TValue, string][];

export const selectOptionsFromDisplayValues = <TValue extends string>(
  displayValues: DisplayValuesMap<TValue>,
): SelectOption<TValue>[] =>
  displayValueEntries(displayValues).map(([value, label]) => ({
    id: value,
    value,
    label,
  }));

export const selectOptionValuesToNumbers = (options: SelectOption[]): SelectOption<number>[] =>
  options.map((option) => ({ ...option, value: Number(option.value) }));

export const notEmpty = <TValue>(value: TValue) =>
  !(<unknown[]>[undefined, null, '']).includes(value);

export const getEmptyResultSet = <TData>(page: number, pageSize: number): PaginatedData<TData> => ({
  results: [],
  page,
  pageSize,
  pageCount: 1,
  totalResults: pageSize,
});
